export const zh = {
  // 通用
  common: {
    language: 'zh'
  },

  // 导航栏
  nav: {
    home: '首页',
    product: '产品',
    demo: '功能演示',
    solutions: '解决方案',
    cases: '客户案例',
    pricing: '定价',
    resources: '资源',
    login: '登录',
    freeTrial: '免费试用'
  },

  // Hero区域
  hero: {
    badge: 'DecisionAI 2.0 全新升级',
    brand: 'DecisionAI',
    title: {
      line1: '让数据开口说话',
      line2: '让决策更加智能'
    },
    subtitle: 'Agent + Tool 智能调度架构，3分钟让Oracle数据库变身AI助手',
    features: {
      scheduling: '智能调度',
      oracle: 'Oracle 原生支持',
      config: '极简配置'
    },
    description: {
      line1: 'Oracle原生支持',
      line2: '多模数据融合',
      line3: '私有知识上云'
    },
    cta: {
      primary: '立即体验 - 免费试用',
      secondary: '了解更多'
    },
    highlights: {
      oracle: {
        title: 'Oracle',
        subtitle: '原生深度整合'
      },
      agent: {
        title: 'Agent+Tool',
        subtitle: '智能调度架构'
      },
      code: {
        title: '0代码',
        subtitle: '极简配置上线'
      }
    },
    rightPanel: {
      analysis: '实时数据分析',
      insight: 'AI智能洞察',
      decision: '决策建议'
    },
    scrollHint: '向下滚动探索更多'
  },

  // Demo区域
  demo: {
    title: '体验 DAI 2.0 Agent + Tool 智能调度',
    subtitle: '观看 Agent 如何智能分解复杂任务，动态调度多种 Tool 协同工作，实现多模数据融合分析。',

    // 引导相关
    guide: {
      title: '开始您的AI演示之旅',
      subtitle: '选择一个行业场景，体验AI智能分析的强大能力',
      step1: '选择行业',
      step1Desc: '从电商、制造、金融中选择您感兴趣的行业',
      step2: '选择问题',
      step2Desc: '选择一个具体的业务问题进行分析',
      step3: '开始演示',
      step3Desc: '点击开始按钮，观看AI智能分析过程',
      skip: '跳过引导',
      startHere: '从这里开始！选择一个行业',
      selectQuestionHint: '现在选择一个问题进行分析',
      clickToStart: '点击发送开始AI演示！'
    },
    showcase: {
      title: 'Agent + Tool 智能调度演示',
      subtitle: '选择领域和问题，体验智能分析流程',
      selectDomain: '选择分析领域',
      selectQuestion: '选择问题',
      back: '返回',
      currentQuestion: '当前问题'
    },
    industries: {
      ecommerce: {
        title: '电商零售',
        subtitle: '零售电商数据分析'
      },
      manufacturing: {
        title: '生产制造',
        subtitle: '制造业生产数据分析'
      },
      finance: {
        title: '金融服务',
        subtitle: '金融业务数据分析'
      }
    },
    questions: {
      retail: {
        sales: '销售数据分析',
        salesQuestion: '最近一个月销量下滑的原因是什么？',
        salesTags: ['销售', '趋势分析'],
        product: '产品表现分析',
        productQuestion: '过去一年，哪些产品卖的好？',
        productTags: ['产品', '销售排名'],
        customer: '客户行为洞察',
        customerQuestion: '分析客户购买行为，识别高价值客户群体',
        customerTags: ['客户', '行为分析']
      },
      manufacturing: {
        efficiency: '生产效率分析',
        efficiencyQuestion: '帮我分析各基地3月份每日排产目标',
        efficiencyTags: ['生产', '效率'],
        operation: '工厂运营分析',
        operationQuestion: '宜兴各个工厂的每日趋势怎么样?',
        operationTags: ['工厂', '趋势'],
        quality: '质量控制分析',
        qualityQuestion: '上个月三个基地的碎片是多少？',
        qualityTags: ['质量', '控制']
      },
      finance: {
        risk: '风险评估分析',
        riskQuestion: '请帮我评估一下abc公司是否存在贷款风险',
        riskTags: ['风险', '评估'],
        portfolio: '投资组合优化',
        portfolioQuestion: '基于历史收益数据，优化投资组合配置建议',
        portfolioTags: ['投资', '优化'],
        fraud: '交易异常检测',
        fraudQuestion: '识别异常交易模式，提升反欺诈能力',
        fraudTags: ['异常', '检测']
      }
    },
    assistant: {
      title: 'DecisionAI 助手',
      subtitle: '智能数据分析专家',
      status: '在线',
      placeholder: '请先在左侧选择一个分析问题',
      inputPlaceholder: '点击发送开始分析...',
      demoNote: '这是演示环境，实际产品支持连接您的真实数据源'
    },
    toolScheduling: {
      agentScheduling: '🔄 Agent 智能调度中...',
      tools: {
        sqlTool: 'SQL Tool',
        graphTool: 'Graph Tool',
        vectorTool: 'Vector Tool'
      }
    },
    cta: {
      title: '准备好体验 Agent + Tool 智能数据平台了吗？',
      subtitle: '几分钟内让您的Oracle数据库"开口说话"，体验多模数据融合分析的强大能力',
      primary: '开始免费试用',
      secondary: '预约产品演示'
    },
    analysis: {
      reselect: '重新选择',
      restartDemo: '重新开始演示',
      demoInProgress: '演示进行中...',
      phases: {
        intentConfirmation: '问题提出 + 意图确认',
        basicInfoQuery: '基本信息查询',
        riskAnalysis: '风险综合分析',
        riskReport: '风险评估报告',
        dataAnalysis: '数据分析',
        reportGeneration: '报告生成',
        portfolioAnalysis: '投资组合分析',
        anomalyDetection: '异常检测',
        productionAnalysis: '生产分析',
        qualityAnalysis: '质量分析',
        trendAnalysis: '趋势分析'
      },
      descriptions: {
        intentConfirmation: 'AI确认用户意图并制定分析计划',
        basicInfoQuery: '获取公司基本注册信息和信用状况',
        riskAnalysis: '多维度分析公司风险状况',
        riskReport: '生成完整的风险评估报告和风控建议',
        dataAnalysis: '分析数据模式和趋势',
        reportGeneration: '生成综合分析报告',
        portfolioAnalysis: '分析投资组合表现',
        anomalyDetection: '检测数据中的异常模式',
        productionAnalysis: '分析生产效率和目标',
        qualityAnalysis: '分析质量控制指标',
        trendAnalysis: '分析时间趋势和模式',

        // 投资组合相关
        portfolioHistoricalAnalysis: '分析各类资产的历史收益表现',
        portfolioOptimization: '计算最优投资组合配置方案',
        portfolioReport: '生成完整的投资组合优化报告',

        // 电商零售相关
        salesTrendQuery: 'SQL Tool执行数据查询，确认销售下滑趋势',
        multiToolAnalysis: 'Agent调度多Tool并行分析，全面诊断问题',
        analysisReport: '生成完整的分析报告和决策建议',
        productProfitQuery: 'SQL Tool执行数据查询，获取产品利润排行',
        productFeatureAnalysis: 'Agent调度多Tool分析，深度挖掘产品特征',
        productInsightReport: '生成产品洞察报告和营销建议',
        productCategoryAnalysis: '深入分析产品类别和品牌特征',
        productStrategyReport: '生成完整的产品分析报告和策略建议',
        customerBehaviorQuery: 'SQL Tool执行数据查询，分析客户行为',
        customerFeatureAnalysis: 'Agent调度多Tool深度分析客户特征',
        customerValueReport: '生成客户价值分析和运营建议',

        // 客户行为洞察相关
        customerSpendingAnalysis: '分析客户消费金额分布和价值分层',
        customerGroupAnalysis: '深入分析不同价值客户群体的行为特征',
        customerInsightReport: '生成完整的客户价值洞察报告和营销策略',

        // 金融风控相关
        transactionDataPreprocessing: '获取交易数据并进行预处理分析',
        fraudDetectionAlgorithms: '运用多种算法识别异常交易模式',
        fraudMonitoringReport: '生成完整的反欺诈监控报告和处理建议',
        mlFraudDetection: '应用机器学习算法识别异常交易',
        fraudControlPlan: '生成反欺诈监控建议和风控方案',

        // 生产制造相关
        productionSchedulingQuery: 'SQL Tool执行数据查询，获取排产数据',
        productionTrendAnalysis: 'Agent调度多Tool分析排产趋势',
        productionOptimizationReport: '生成排产优化建议和改进方案',
        factoryPerformanceQuery: 'SQL Tool执行数据查询，获取工厂表现数据',
        factoryEfficiencyAnalysis: 'Agent调度多Tool分析工厂效率',
        factoryOptimizationReport: '生成工厂优化建议和管理方案',
        qualityDataQuery: 'SQL Tool执行数据查询，获取质量数据',
        qualityIssueDiagnosis: 'Agent调度多Tool诊断质量问题',
        qualityImprovementReport: '生成质量改进建议和控制方案',

        // 生产制造具体描述
        dailyProductionTargetQuery: '查询各基地3月份每日排产目标数据',
        productionTrendDetailAnalysis: '深入分析各基地排产趋势和特点',
        productionAnalysisReport: '生成完整的排产分析报告和优化建议',
        factoryKeyIndicatorQuery: '查询宜兴基地各工厂每日关键指标',
        factoryPerformanceDetailAnalysis: '深入分析各工厂表现差异和趋势',
        factoryAnalysisReport: '生成完整的工厂分析报告和优化建议',
        fragmentationRateQuery: '查询并统计各基地碎片率数据',
        qualityControlAnalysis: '深入分析各基地质量控制差异原因',
        qualityAnalysisReport: '生成完整的质量分析报告和改进建议'
      },

      // Demo对话内容
      content: {
        // 意图确认
        intentConfirmation: {
          title: '✓ **意图确认完成**',
          analysisIntent: '🎯 **分析意图**',
          executionPlan: '📋 **执行步骤规划**'
        },

        // 工具执行
        toolExecution: {
          sqlQuery: '🔍 **执行工具: 自动SQL查询**',
          duration: '⏱️ **耗时: {duration} ms**',
          queryResults: '📊 **查询结果**',
          chartAnalysis: '📈 **智能图表分析**',
          chartGenerated: '图表已生成'
        },

        // Agent调度
        agentScheduling: {
          multiTool: '🔄 **Agent智能调度多Tool并行分析**',
          keyFindings: '🎯 **关键发现**',
          comparison: '📈 **对比分析**'
        },

        // 通用短语
        common: {
          decrease: '下降',
          increase: '上升',
          stable: '稳定',
          normal: '正常',
          abnormal: '异常',
          high: '高',
          medium: '中',
          low: '低',
          risk: '风险',
          warning: '⚠️',
          success: '✅',
          yuan: '元',
          percent: '%'
        }
      }
    }
  },

  // 产品价值
  productValue: {
    badge: 'DecisionAI 2.0 核心价值',
    title: 'AI Agent重新定义数据分析',
    subtitle: '从传统的数据查询工具，升级为智能决策助手',
    values: {
      naturalLanguage: {
        title: '自然语言交互',
        description: '像聊天一样问数据，0代码门槛',
        benefit: '降低使用门槛90%'
      },
      aiInsight: {
        title: 'AI智能洞察',
        description: '自动发现数据规律，生成业务洞察', 
        benefit: '分析效率提升10倍'
      },
      smartScheduling: {
        title: '智能调度架构',
        description: 'Agent + Tool 协同工作',
        benefit: '多模数据融合分析'
      },
      precisionDecision: {
        title: '精准决策建议',
        description: '基于数据生成可执行的决策建议',
        benefit: '决策准确率提升80%'
      }
    }
  },

  // 产品价值
  productValue: {
    badge: 'DecisionAI 2.0 核心价值',
    title: 'AI Agent重新定义数据分析',
    subtitle: '从传统的数据查询工具，升级为智能决策助手',
    values: {
      naturalLanguage: {
        title: '自然语言交互',
        description: '像聊天一样问数据，0代码门槛',
        benefit: '降低使用门槛90%'
      },
      aiInsight: {
        title: 'AI智能洞察',
        description: '自动发现数据规律，生成业务洞察',
        benefit: '分析效率提升10倍'
      },
      smartScheduling: {
        title: '智能调度架构',
        description: 'Agent + Tool 协同工作',
        benefit: '多模数据融合分析'
      },
      precisionDecision: {
        title: '精准决策建议',
        description: '基于数据生成可执行的决策建议',
        benefit: '决策准确率提升80%'
      }
    },
    industryScenarios: {
      title: '行业应用场景',
      subtitle: '针对不同行业特点，提供专业的AI数据分析解决方案',
      selectorTitle: '选择您的行业',
      selectorSubtitle: '探索专为您行业定制的AI解决方案'
    },
    whyChooseUs: {
      title: '为什么选择 DecisionAI？',
      point1: '深度行业经验，懂您的业务',
      point2: 'Oracle原生支持，数据安全可靠',
      point3: '3分钟快速部署，立即见效'
    },
    viewAllIndustries: '查看全部行业解决方案',
    caseStudy: {
      title: '客户案例'
    },
    demoQuestions: {
      title: '常见分析问题'
    },
    industryStats: {
      title: '行业领先数据'
    }
  },

  // 行业应用场景详细内容
  industries: {
    ecommerce: {
      title: '电商零售',
      subtitle: 'AI驱动的智能商业决策',
      description: '对话式数据分析，让每个运营都能成为数据专家',
      briefDesc: '专注电商零售业务场景，涵盖用户、商品、营销全链路',
      keyMetric: '🎆 客户运营效率提升60%',
      features: {
        userProfile: {
          title: '智能用户画像',
          description: 'AI自动分析用户行为，精准识别高价值客户',
          metric: '会员客单价提升15%'
        },
        productPrediction: {
          title: '爆品预测分析',
          description: '基于历史数据和市场趋势，AI预测潜在爆品',
          metric: '爆品识别准确率85%'
        },
        adOptimization: {
          title: '智能投放优化',
          description: 'AI实时优化广告投放策略，降低获客成本',
          metric: '投放ROI提升25%'
        }
      },
      caseStudy: {
        company: '某知名电商平台',
        result: '使用DecisionAI后，运营效率提升60%，决策时间从天级缩短到分钟级'
      },
      demoQuestions: [
        '本月哪个产品类别销售增长最快？',
        '高价值用户的购买行为有什么特征？',
        '如何优化广告投放提升转化率？'
      ]
    },
    manufacturing: {
      title: '生产制造',
      subtitle: 'AI赋能的智能制造决策',
      description: '从生产数据到经营洞察，AI助力制造业数字化转型',
      briefDesc: '深耕制造业20年，懂生产、懂质量、懂经营',
      keyMetric: '🏆 生产效率提升35%',
      features: {
        qualityMonitoring: {
          title: '智能质量监控',
          description: 'AI实时分析生产数据，预警质量风险',
          metric: '质量问题预警准确率92%'
        },
        supplyChain: {
          title: '供应链优化',
          description: 'AI优化库存管理，降低资金占用',
          metric: '库存周转率提升30%'
        },
        predictiveMaintenance: {
          title: '设备预测维护',
          description: '基于设备数据，AI预测维护需求',
          metric: '设备故障率降低40%'
        }
      },
      caseStudy: {
        company: '某大型制造企业',
        result: '通过AI数据分析，生产效率提升35%，运营成本降低20%'
      },
      demoQuestions: [
        '哪条生产线的效率最高？',
        '原材料库存是否需要补充？',
        '设备维护计划如何安排？'
      ]
    },
    franchise: {
      title: '连锁加盟',
      subtitle: 'AI驱动的连锁经营管理',
      description: '统一数据标准，AI洞察助力连锁品牌规模化发展',
      briefDesc: '一站式连锁管理平台，让每家门店都成为最优店',
      keyMetric: '📈 门店人效提升45%',
      features: {
        storeAnalysis: {
          title: '门店经营分析',
          description: 'AI分析各门店经营数据，识别最佳实践',
          metric: '门店人效提升45%'
        },
        locationRecommendation: {
          title: '选址智能推荐',
          description: '基于人流、竞争等数据，AI推荐最佳选址',
          metric: '新店成功率提升60%'
        },
        franchiseeSupport: {
          title: '加盟商支持',
          description: 'AI生成个性化经营建议，提升加盟商盈利',
          metric: '加盟商满意度95%'
        }
      },
      caseStudy: {
        company: '某知名连锁品牌',
        result: 'AI数据分析帮助优化门店运营，整体盈利能力提升28%'
      },
      demoQuestions: [
        '哪家门店的经营模式最值得推广？',
        '新开门店应该选择什么位置？',
        '如何提升加盟商的经营效率？'
      ]
    },
    finance: {
      title: '金融服务',
      subtitle: 'AI驱动的智能风控决策',
      description: '实时风险评估，AI助力金融机构精准决策',
      briefDesc: '多模数据融合分析，全方位识别金融风险',
      keyMetric: '🔒 风险识别准确率96%',
      features: {
        riskControl: {
          title: '智能风控模型',
          description: 'AI实时评估客户信用风险，降低坏账率',
          metric: '风险识别准确率96%'
        },
        customerValue: {
          title: '客户价值分析',
          description: 'AI分析客户行为，识别高价值客户',
          metric: '客户价值提升40%'
        },
        productRecommendation: {
          title: '产品推荐引擎',
          description: '基于客户画像，AI推荐合适的金融产品',
          metric: '产品转化率提升55%'
        }
      },
      caseStudy: {
        company: '某城商银行',
        result: 'AI风控系统上线后，风险损失降低50%，业务效率提升3倍'
      },
      demoQuestions: [
        '这个客户的信用风险如何？',
        '哪些产品最适合推荐给这类客户？',
        '如何优化风控策略？'
      ]
    }
  },

  // 行业统计数据
  industryStats: {
    clients: {
      number: '500+',
      label: '企业客户',
      description: '覆盖各行各业'
    },
    accuracy: {
      number: '99.9%',
      label: '准确率',
      description: 'AI分析准确率'
    },
    efficiency: {
      number: '10倍',
      label: '效率提升',
      description: '相比传统方式'
    },
    response: {
      number: '秒级',
      label: '响应速度',
      description: '实时数据分析'
    }
  },

  // 产品特性展示
  featureShowcase: {
    naturalLanguage: {
      mainTitle: '自然语言问数',
      subTitle: 'AI大模型自助式分析每个人都可0门槛使用的数据分析助手',
      details: [
        '自然语言直接问数',
        '智能追问多轮对话',
        '自动生成多种图表'
      ]
    },
    smartAgent: {
      mainTitle: '智能指标Agent',
      subTitle: '每个指标都有极速、专业洞察',
      details: [
        '0代码构建企业级指标模型',
        '层层下钻，多维分析',
        'AI数据洞察，一键生成专业报告'
      ]
    },
    zeroHallucination: {
      mainTitle: '数据分析大模型0幻觉',
      subTitle: '每次问答都稳定、可信',
      details: [
        'RGA+企业知识库',
        '独创要素抽取与关键词高亮',
        '每次数据问答准确率都在100%'
      ]
    }
  },

  // 核心特性区域
  coreCapabilities: {
    title: 'DAI 2.0 核心特性',
    mainTitle: 'Agent + Tool 架构，让数据智能真正落地',
    description: '深度整合 Oracle 高级特性，基于 Agent 智能调度多种 Tool，实现从自然语言提问到洞察报告的全流程自动化。',

    oracleAdvanced: {
      title: 'Oracle 高级特性原生支持',
      subtitle: '图数据库 + 向量数据库深度整合',
      description: 'DAI 2.0 深度整合了 Oracle 数据库的高级数据能力，支持复杂关系路径、网络分析、资金流向链分析等高级业务场景',
      features: [
        '图数据库：复杂关系路径、网络分析',
        '向量数据库：非结构化文本相似度搜索',
        '自动化生成 Graph 查询逻辑',
        '企业文本数据语义检索'
      ],
      metrics: {
        capability: '多模',
        analysis: '高级',
        integration: '原生'
      },
      demo: '分析资金流向链：A公司 → B公司 → C公司的完整路径'
    },

    agentTool: {
      title: 'Agent + Tool 智能调度',
      subtitle: '任务分解 + 动态调度架构',
      description: 'DAI 2.0 构建了基于 Agent + Tool 的模块化智能执行架构，实现任务意图识别、任务分解和动态调度',
      features: [
        '任务意图识别：自动判断分析复杂度',
        '任务分解：复杂任务拆解为多个子任务',
        'Tool调度：SQL、Graph、API工具智能调度',
        '自定义扩展：企业算法一键注册为Tool'
      ],
      metrics: {
        automation: '智能',
        scalability: '可扩展',
        integration: '无缝'
      },
      demo: '风控分析 = SQL Tool(财务表) + Graph Tool(资金路径) + Vector Tool(舆情文本)'
    },

    simpleConfig: {
      title: '极简配置，低门槛上线',
      subtitle: '开箱即用的上手体验',
      description: '带来"开箱即用"的上手体验——哪怕没有专业数据工程师，也能在几分钟内让 DAI 2.0 读懂企业数据库并开始回答问题',
      features: [
        '几分钟内读懂企业数据库',
        '无需专业数据工程师',
        '自动识别数据结构和关系',
        '零代码配置启动'
      ],
      metrics: {
        setup: '几分钟',
        threshold: '零门槛',
        expertise: '无需专业'
      },
      demo: '连接数据库 → 自动识别表结构 → 立即开始问答'
    },

    comprehensiveAnalysis: {
      title: '综合分析 & 智能报告',
      subtitle: '多源多模数据联动分析',
      description: '相比传统技术，DAI 2.0 先"掘地三尺"联动多源、多模数据，再输出一份可直接决策的洞察报告',
      features: [
        '多源数据自动关联分析',
        '多模态数据融合处理',
        '智能生成决策洞察报告',
        '从数据到决策的全流程自动化'
      ],
      metrics: {
        sources: '多源',
        modality: '多模',
        output: '决策级'
      },
      demo: '自动生成：《Q4销售下滑根因分析及改进建议报告》'
    }
  },

  // 工作流程区域
  workflowProcess: {
    title: 'DAI 2.0 工作流程',
    mainTitle: '从自然语言到洞察报告的全流程自动化',
    description: 'DAI 2.0 把「多模 Oracle 数据能力」+「大模型 Agent 调度」+「零门槛自动配置」融合成闭环，完成从自然语言提问到洞察报告的全流程自动化。',

    oracleFeatures: {
      title: 'Oracle 高级特性原生支持',
      graphDatabase: {
        title: '图数据库',
        description: '复杂关系路径、网络分析、资金流向链分析'
      },
      vectorDatabase: {
        title: '向量数据库',
        description: '非结构化文本、语义检索、相似度搜索'
      },
      traditionalSQL: {
        title: '传统SQL',
        description: '结构化数据查询、统计分析、报表生成'
      }
    },

    workflowSteps: {
      naturalLanguage: {
        title: '自然语言提问',
        description: '用户用自然语言提出复杂业务问题',
        example: '分析A公司的整体风险状况，包括财务、关联关系和舆情',
        details: [
          '支持中英文自然语言',
          '理解复杂业务场景',
          '自动识别分析意图',
          '判断任务复杂度'
        ]
      },
      taskDecomposition: {
        title: '任务分解 + 动态调度',
        description: 'Agent智能分解任务，动态调度多种Tool',
        example: 'Task 1: SQL Tool → Task 2: Graph Tool → Task 3: Vector Tool',
        details: [
          '任务意图识别',
          '复杂任务智能拆解',
          '多Tool协同调度',
          '实时执行监控'
        ]
      },
      multiToolExecution: {
        title: '多任务执行',
        description: '多种Tool并行执行，融合多模数据',
        example: 'SQL + Graph + Vector 数据融合分析',
        details: [
          'SQL Tool: 财务数据查询',
          'Graph Tool: 关系路径分析',
          'Vector Tool: 舆情文本检索',
          'API Tool: 外部系统集成'
        ]
      },
      insightReport: {
        title: '洞察报告',
        description: '生成可直接决策的综合分析报告',
        example: '《A公司综合风险评估报告》- 高风险，建议暂停合作',
        details: [
          '多源数据综合分析',
          '智能洞察发现',
          '决策建议生成',
          '可视化图表展示'
        ]
      }
    },

    coreAdvantages: {
      title: 'Agent + Tool 架构的核心优势',
      privateKnowledge: {
        title: '私有知识快速上云',
        description: '企业专家经验一键注册为Tool，无需修改底层代码'
      },
      multiModalFusion: {
        title: '多模数据融合',
        description: 'SQL + Graph + Vector 一站式完成复杂分析'
      },
      fastIteration: {
        title: '迭代速度快',
        description: '新需求快速响应，现有流程无需改动'
      }
    },

    exampleLabel: '示例：'
  },

  // 核心特性底部统计数据
  capabilitiesStats: {
    oracle: {
      number: 'Oracle',
      label: '原生深度整合',
      description: '图数据库+向量数据库'
    },
    efficiency: {
      number: '10倍',
      label: '效率提升',
      description: '相比传统BI工具'
    },
    accuracy: {
      number: '99.9%',
      label: '准确率',
      description: '数据分析准确性'
    },
    zeroCode: {
      number: '0代码',
      label: '使用门槛',
      description: '人人都能用'
    }
  },

  // AI智能化能力区域
  aiFeatures: {
    badge: 'AI 智能化能力',
    title: '解决"大模型单打独斗"的核心痛点',
    description: 'DAI 2.0 通过 Agent + Tool 架构，让数据智能真正落地企业，实现私有知识快速上云、多模数据融合分析',
    features: {
      privateKnowledge: {
        title: '私有知识快速上云',
        description: '企业专家经验一键注册为Tool，无需修改底层代码',
        details: [
          '财务专家SQL → 一键注册为finance_risk_score_tool',
          '业务人员提问时Agent自动调度',
          '无需再找DBA，专家经验直接复用',
          '企业知识资产快速数字化'
        ]
      },
      multimodalFusion: {
        title: '多模数据融合一站式完成',
        description: '复杂业务问题通过多种Tool协同解决',
        details: [
          '风控问题 = SQL Tool(财务表) + Graph Tool(资金路径)',
          '舆情分析 = Vector Tool(舆情文本) + SQL Tool(业务数据)',
          'Agent负责拆分与编排，统一输出综合报告',
          '一个问题，多种数据源，一份答案'
        ]
      },
      fastIteration: {
        title: '迭代速度快',
        description: '新需求快速响应，现有流程无需改动',
        details: [
          '新法规要求追加"环保风险API"',
          '只需封装成Tool并在配置中声明',
          '现有Agent流程无需改动',
          '业务变化快速适应'
        ]
      },
      enterpriseReliability: {
        title: '企业级可靠性',
        description: '解决大模型幻觉问题，确保分析结果准确可信',
        details: [
          '基于RAG技术，数据来源可追溯',
          '企业知识库实时更新验证',
          '多重验证机制保障准确性',
          '分析结果可解释、可审计'
        ]
      }
    },
    cta: {
      title: '体验企业级AI数据智能平台',
      description: 'DAI 2.0 让企业数据智能真正落地，几分钟内让您的数据库"开口说话"，立即开始Agent + Tool的智能数据之旅',
      primary: '免费试用',
      secondary: '预约演示'
    }
  },

  // 对比分析区域
  comparison: {
    badge: '对比分析',
    title: 'DAI 2.0 vs 传统BI工具',
    description: '基于真实演示案例，看看DAI 2.0如何重新定义数据分析的效率和深度',
    traditional: {
      title: '传统BI工具'
    },
    dai: {
      title: 'DAI 2.0'
    },
    categories: {
      usage: {
        title: '使用方式',
        traditional: [
          { text: '需要学习SQL语法', icon: '❌' },
          { text: '依赖技术人员支持', icon: '❌' },
          { text: '预设报表模板', icon: '❌' },
          { text: '手动数据关联', icon: '❌' }
        ],
        dai: [
          { text: '自然语言直接提问', icon: '✅', example: '"最近一个月销量下滑的原因是什么？"' },
          { text: '业务人员自助分析', icon: '✅', example: '0代码门槛，即问即答' },
          { text: 'AI智能生成分析', icon: '✅', example: '自动分解为5个分析步骤' },
          { text: '多维度自动关联', icon: '✅', example: '产品→品牌→促销→退货全链路' }
        ]
      },
      depth: {
        title: '分析深度',
        traditional: [
          { text: '单一维度查询', icon: '❌' },
          { text: '静态报表展示', icon: '❌' },
          { text: '需要人工解读', icon: '❌' },
          { text: '缺乏决策建议', icon: '❌' }
        ],
        dai: [
          { text: '多维度深度分析', icon: '✅', example: '总体→类别→品牌→促销→退货' },
          { text: '智能图表生成', icon: '✅', example: '自动生成可视化图表' },
          { text: 'AI智能洞察', icon: '✅', example: '自动识别关键问题和趋势' },
          { text: '生成决策建议', icon: '✅', example: '具体的业务行动方案' }
        ]
      },
      technology: {
        title: '技术能力',
        traditional: [
          { text: '单一数据源', icon: '❌' },
          { text: '固定查询逻辑', icon: '❌' },
          { text: '人工配置复杂', icon: '❌' },
          { text: '扩展能力有限', icon: '❌' }
        ],
        dai: [
          { text: 'Oracle多模数据融合', icon: '✅', example: '关系+图+向量数据库' },
          { text: 'Agent智能调度', icon: '✅', example: '动态生成SQL查询逻辑' },
          { text: '私有知识快速上云', icon: '✅', example: '专家经验一键注册' },
          { text: 'Tool生态可扩展', icon: '✅', example: '新需求快速响应' }
        ]
      }
    },
    realCase: {
      title: '真实案例对比',
      question: '最近一个月销量下滑的原因是什么？',
      traditionalTitle: '传统BI工具流程',
      daiTitle: 'DAI 2.0 流程',
      resultLabel: '结果：',
      traditionalProcess: [
        '1. 业务人员提出需求',
        '2. 等待技术人员排期',
        '3. 编写SQL查询语句',
        '4. 手动生成多个报表',
        '5. 人工分析数据关联',
        '6. 撰写分析报告',
        '⏱️ 耗时：2-3天'
      ],
      daiProcess: [
        '1. 自然语言直接提问',
        '2. Agent智能任务分解',
        '3. 自动生成SQL查询',
        '4. 多维度数据分析',
        '5. 智能图表生成',
        '6. AI洞察报告输出',
        '⚡ 耗时：3分钟'
      ],
      result: {
        traditional: '获得基础数据报表，需要人工解读',
        dai: '获得深度分析报告 + 具体决策建议：\n• 电脑类别销售额下降214万\n• 戴尔、华为等品牌表现不佳\n• 五一促销活动结束影响\n• 建议针对性促销策略'
      }
    },
    mobileHint: '💡 提示：左右滑动查看不同对比维度，点击卡片查看详细对比',
    moreAdvantages: '更多优势',
    summary: {
      timeImprovement: '从天级到分钟级',
      dataToDecision: '从数据到决策',
      dependencyToSelfService: '从依赖到自助'
    }
  },

  // 通用按钮和操作
  common: {
    learnMore: '了解更多',
    getStarted: '开始使用',
    freeTrial: '免费试用',
    bookDemo: '预约演示',
    viewDetails: '查看详情',
    close: '关闭',
    demo: '演示示例',
    aiAnalyzing: 'AI智能分析中',
    privateKnowledge: '私有知识',
    multimodalFusion: '多模态融合',
    fastIteration: '快速迭代',
    enterpriseReliable: '企业可靠',
    dataEncryption: '数据加密',
    accessControl: '访问控制',
    auditLog: '审计日志',
    next: '下一步',
    previous: '上一步',
    loading: '加载中...',
    error: '出错了',
    retry: '重试',

    // 数据类型
    structured: '结构化',
    graphData: '图数据',
    vector: '向量',

    // 开发流程
    requirementAnalysis: '需求分析',
    rapidDevelopment: '快速开发',
    testing: '测试验证',
    deployment: '部署上线',

    // 性能指标
    accuracy: '准确率',
    availability: '可用性',
    responseTime: '响应时间',
    securityLevel: '安全等级'
  },

  // 视频播放器
  video: {
    title: '产品演示视频',
    unsupported: '您的浏览器不支持视频播放',
    openInNewWindow: '在新窗口中观看',
    download: '下载',
    playbackSpeed: '播放速度',
    pictureInPicture: '画中画'
  },

  // 产品页面
  product: {
    seo: {
      title: '产品介绍 - DecisionAI 2.0 | 企业级AI数据智能平台',
      description: '了解DecisionAI 2.0的核心功能特性，Agent + Tool智能调度架构，Oracle原生支持，自然语言交互等企业级AI数据分析能力。'
    },
    hero: {
      badge: 'DecisionAI 2.0 产品介绍',
      title: '重新定义',
      titleHighlight: ' AI 数据分析',
      subtitle: '基于 Agent + Tool 架构，深度整合 Oracle 高级特性，实现从自然语言提问到洞察报告的全流程自动化',
      cta: {
        trial: '免费试用',
        demo: '预约演示'
      }
    },
    features: {
      title: '核心功能特性',
      subtitle: '四大核心能力，让数据智能真正落地企业',
      items: {
        nlp: {
          title: '自然语言交互',
          description: '像聊天一样问数据，0代码门槛',
          details: [
            '支持中英文自然语言提问',
            '智能理解复杂业务场景',
            '多轮对话上下文记忆',
            '自动纠错和澄清机制'
          ]
        },
        agent: {
          title: 'Agent + Tool 智能调度',
          description: '任务分解 + 动态调度架构',
          details: [
            '智能任务分解与规划',
            '多Tool协同工作',
            '动态资源调度优化',
            '实时执行状态监控'
          ]
        },
        oracle: {
          title: 'Oracle 原生支持',
          description: '图数据库 + 向量数据库深度整合',
          details: [
            '原生支持Oracle高级特性',
            '图数据库复杂关系分析',
            '向量数据库语义检索',
            '多模数据融合处理'
          ]
        },
        config: {
          title: '极简配置上线',
          description: '开箱即用的上手体验',
          details: [
            '几分钟内读懂企业数据库',
            '无需专业数据工程师',
            '自动识别数据结构和关系',
            '零代码配置启动'
          ]
        }
      }
    },
    useCases: {
      title: '应用场景',
      subtitle: '针对不同行业特点，提供专业的AI数据分析解决方案',
      items: {
        ecommerce: {
          title: '电商零售',
          description: '智能用户画像、爆品预测、投放优化',
          benefits: ['会员客单价提升15%', '爆品识别准确率85%', '投放ROI提升25%']
        },
        finance: {
          title: '金融服务',
          description: '风险评估、反欺诈、智能投顾',
          benefits: ['风险识别准确率95%', '欺诈检测效率提升80%', '投资建议精准度90%']
        },
        manufacturing: {
          title: '生产制造',
          description: '供应链优化、质量控制、预测维护',
          benefits: ['库存成本降低20%', '质量问题减少60%', '设备故障预测准确率85%']
        }
      }
    },
    cta: {
      title: '准备好体验 DecisionAI 2.0 了吗？',
      subtitle: '几分钟内让您的Oracle数据库"开口说话"',
      buttons: {
        trial: '开始免费试用',
        demo: '预约产品演示'
      }
    }
  },

  // 解决方案页面
  solutions: {
    seo: {
      title: '解决方案 - DecisionAI 2.0 | 行业AI数据分析解决方案',
      description: 'DecisionAI 2.0为电商零售、金融服务、生产制造等行业提供专业的AI数据分析解决方案，助力企业数字化转型。'
    },
    hero: {
      badge: '行业解决方案',
      title: '针对不同行业',
      titleHighlight: ' 量身定制',
      subtitle: '基于深度行业理解，为电商零售、金融服务、生产制造等行业提供专业的AI数据分析解决方案'
    },
    industries: {
      ecommerce: {
        name: '电商零售',
        title: 'AI驱动的智能商业决策',
        description: '对话式数据分析，让每个运营都能成为数据专家',
        challenges: [
          '传统BI工具响应慢，业务人员依赖技术团队',
          '数据分析周期长达2-3天，错失商机',
          '缺乏实时洞察，难以快速调整策略'
        ],
        solutions: [
          {
            title: '智能用户画像',
            description: 'AI自动分析用户行为，精准识别高价值客户',
            result: '会员客单价提升15%'
          },
          {
            title: '爆品预测分析',
            description: '基于历史数据和市场趋势，AI预测潜在爆品',
            result: '爆品识别准确率85%'
          },
          {
            title: '智能投放优化',
            description: 'AI实时优化广告投放策略，降低获客成本',
            result: '投放ROI提升25%'
          }
        ],
        caseStudy: {
          company: '某知名电商平台',
          description: '日均订单量100万+，需要实时分析用户行为和销售趋势',
          results: [
            '分析效率提升60%，从天级缩短到分钟级',
            '决策时间缩短90%，从2-3天到3分钟',
            '自助分析率提升80%，业务人员独立完成分析'
          ]
        }
      },
      finance: {
        name: '金融服务',
        title: 'AI驱动的智能风控决策',
        description: '实时风险评估，智能反欺诈，精准投资建议',
        challenges: [
          '风险评估依赖人工经验，效率低下',
          '欺诈检测滞后，损失难以挽回',
          '投资决策缺乏数据支撑'
        ],
        solutions: [
          {
            title: '智能风险评估',
            description: '多维度数据融合，实时评估客户风险等级',
            result: '风险识别准确率95%'
          },
          {
            title: '反欺诈检测',
            description: 'AI模型实时监控异常交易，快速识别欺诈行为',
            result: '欺诈检测效率提升80%'
          },
          {
            title: '智能投顾服务',
            description: '基于市场数据和用户画像，提供个性化投资建议',
            result: '投资建议精准度90%'
          }
        ],
        caseStudy: {
          company: '某大型银行',
          description: '服务客户超过1000万，需要实时风险控制和智能决策',
          results: [
            '风险评估效率提升70%',
            '欺诈损失减少85%',
            '客户满意度提升40%'
          ]
        }
      },
      manufacturing: {
        name: '生产制造',
        title: 'AI赋能的智能制造决策',
        description: '供应链优化，质量控制，预测性维护',
        challenges: [
          '供应链管理复杂，库存成本高',
          '质量问题发现滞后，影响生产效率',
          '设备维护依赖经验，故障预测困难'
        ],
        solutions: [
          {
            title: '供应链优化',
            description: 'AI分析供需关系，优化库存配置和采购计划',
            result: '库存成本降低20%'
          },
          {
            title: '质量智能控制',
            description: '实时监控生产数据，预测和预防质量问题',
            result: '质量问题减少60%'
          },
          {
            title: '预测性维护',
            description: 'AI分析设备运行数据，预测故障并提前维护',
            result: '设备故障预测准确率85%'
          }
        ],
        caseStudy: {
          company: '某制造业龙头企业',
          description: '拥有50+生产线，需要智能化管理和优化',
          results: [
            '生产效率提升30%',
            '维护成本降低25%',
            '产品质量提升45%'
          ]
        }
      },
      franchise: {
        name: '连锁加盟',
        title: 'AI驱动的连锁经营管理',
        description: '统一数据标准，AI洞察助力连锁品牌规模化发展',
        challenges: [
          '门店数据分散，缺乏统一分析视角',
          '加盟商经营水平参差不齐，难以标准化管理',
          '选址依赖经验，新店成功率低'
        ],
        solutions: [
          {
            title: '门店经营分析',
            description: 'AI分析各门店经营数据，识别最佳实践',
            result: '门店人效提升45%'
          },
          {
            title: '智能选址推荐',
            description: '基于人流、竞争等数据，AI推荐最佳选址',
            result: '新店成功率提升60%'
          },
          {
            title: '加盟商赋能',
            description: 'AI生成个性化经营建议，提升加盟商盈利',
            result: '加盟商满意度95%'
          }
        ],
        caseStudy: {
          company: '某知名连锁品牌',
          description: '全国500+门店，需要统一管理和数据驱动经营',
          results: [
            '整体营收提升35%',
            '门店经营效率提升50%',
            '加盟商续约率提升至90%'
          ]
        }
      }
    },
    common: {
      challenges: '面临挑战',
      solutions: 'DAI 2.0 解决方案',
      caseStudy: '客户成功案例',
      quantifiedResults: '量化成果',
      learnMore: '了解详情'
    },
    cta: {
      title: '想了解您的行业解决方案？',
      subtitle: '联系我们的专家，获取定制化的行业解决方案',
      buttons: {
        consultation: '预约专家咨询',
        trial: '免费试用'
      }
    }
  },

  // 客户案例页面
  cases: {
    seo: {
      title: '客户案例 - DecisionAI 2.0 | 真实客户成功案例',
      description: '查看DecisionAI 2.0在电商零售、金融服务、生产制造等行业的真实客户成功案例，了解量化成果和客户证言。'
    },
    hero: {
      badge: '客户成功案例',
      title: '真实客户',
      titleHighlight: ' 成功故事',
      subtitle: '看看不同行业的客户如何通过DecisionAI 2.0实现数据智能转型，获得显著的业务成果'
    },
    stats: [
      { number: '500+', label: '企业客户', description: '覆盖各行各业' },
      { number: '3分钟', label: '平均分析时间', description: '从问题到洞察' },
      { number: '90%', label: '效率提升', description: '相比传统方式' },
      { number: '99.9%', label: '准确率', description: 'AI分析准确率' }
    ],
    filters: [
      { id: 'all', name: '全部案例' },
      { id: 'ecommerce', name: '电商零售' },
      { id: 'finance', name: '金融服务' },
      { id: 'manufacturing', name: '生产制造' },
      { id: 'logistics', name: '物流运输' }
    ],
    caseStudies: [
      {
        id: 1,
        category: 'ecommerce',
        company: '某大型电商平台',
        industry: '电商零售',
        logo: '🛒',
        challenge: '日均订单量100万+，传统BI工具响应慢，业务人员依赖技术团队，分析周期长达2-3天',
        solution: 'DAI 2.0 Agent + Tool架构，自然语言问数，智能任务分解',
        results: [
          { metric: '分析效率', improvement: '提升60%', detail: '从天级缩短到分钟级' },
          { metric: '决策时间', improvement: '缩短90%', detail: '从2-3天到3分钟' },
          { metric: '自助分析率', improvement: '提升80%', detail: '业务人员独立完成分析' }
        ],
        testimonial: {
          quote: 'DAI 2.0让我们的运营团队第一次能够独立完成复杂的数据分析，从"最近一个月销量下滑的原因是什么？"这样的问题，到获得包含具体决策建议的完整报告，只需要3分钟。',
          author: '数据运营总监',
          company: '某大型电商平台'
        }
      },
      {
        id: 2,
        category: 'finance',
        company: '某知名银行',
        industry: '金融服务',
        logo: '🏦',
        challenge: '风险评估依赖人工经验，欺诈检测滞后，投资决策缺乏数据支撑',
        solution: '多维度风险评估模型，实时反欺诈检测，智能投顾服务',
        results: [
          { metric: '风险识别准确率', improvement: '达到95%', detail: '多维度数据融合分析' },
          { metric: '欺诈检测效率', improvement: '提升80%', detail: '实时监控异常交易' },
          { metric: '客户满意度', improvement: '提升40%', detail: '个性化投资建议' }
        ],
        testimonial: {
          quote: '通过DecisionAI 2.0，我们实现了风险管理的智能化升级，不仅提高了风险识别的准确性，还大幅提升了客户服务质量。',
          author: '风险管理部总监',
          company: '某知名银行'
        }
      },
      {
        id: 3,
        category: 'manufacturing',
        company: '某制造业龙头企业',
        industry: '生产制造',
        logo: '🏭',
        challenge: '供应链管理复杂，质量问题发现滞后，设备维护依赖经验',
        solution: '供应链智能优化，质量预测控制，预测性维护系统',
        results: [
          { metric: '生产效率', improvement: '提升30%', detail: '智能化生产管理' },
          { metric: '维护成本', improvement: '降低25%', detail: '预测性维护' },
          { metric: '产品质量', improvement: '提升45%', detail: '实时质量监控' }
        ],
        testimonial: {
          quote: 'DAI 2.0帮助我们实现了从传统制造向智能制造的转型，生产效率和产品质量都有了显著提升。',
          author: '生产运营总监',
          company: '某制造业龙头企业'
        }
      },
      {
        id: 4,
        category: 'logistics',
        company: '某物流集团',
        industry: '物流运输',
        logo: '🚚',
        challenge: '路线规划复杂，运输成本高，货物追踪不及时',
        solution: '智能路线优化，成本预测分析，实时货物追踪',
        results: [
          { metric: '运输效率', improvement: '提升35%', detail: '智能路线规划' },
          { metric: '运输成本', improvement: '降低20%', detail: '成本优化分析' },
          { metric: '客户满意度', improvement: '提升50%', detail: '实时追踪服务' }
        ],
        testimonial: {
          quote: '通过AI数据分析，我们的物流网络变得更加智能高效，客户体验也得到了大幅提升。',
          author: '运营副总裁',
          company: '某物流集团'
        }
      }
    ],
    common: {
      challenge: '面临挑战',
      solution: '解决方案',
      results: '量化成果'
    },
    cta: {
      title: '成为下一个成功案例',
      subtitle: '加入500+企业客户，开启您的数据智能之旅',
      buttons: {
        trial: '免费试用',
        demo: '预约演示'
      }
    }
  },

  // 定价页面
  pricing: {
    seo: {
      title: '定价方案 - DecisionAI 2.0 | 灵活的企业级AI数据分析定价',
      description: '查看DecisionAI 2.0的定价方案，从免费版到企业版，满足不同规模企业的AI数据分析需求。14天免费试用。'
    },
    hero: {
      badge: '定价方案',
      title: '选择适合您的',
      titleHighlight: ' 定价方案',
      subtitle: '从免费试用到企业级解决方案，我们为不同规模的企业提供灵活的定价选择'
    },
    billing: {
      monthly: '按月付费',
      yearly: '按年付费',
      yearlyDiscount: '省20%'
    },
    plans: [
      {
        name: '免费版',
        price: { monthly: 0, yearly: 0 },
        description: '适合个人用户和小团队试用',
        features: [
          '每月100次查询',
          '基础数据分析',
          '标准图表生成',
          '邮件支持',
          '数据导出功能'
        ],
        limitations: [
          '不支持高级AI模型',
          '不支持自定义集成',
          '数据存储限制1GB'
        ],
        cta: '免费开始',
        popular: false,
        variant: 'outline'
      },
      {
        name: '专业版',
        price: { monthly: 299, yearly: 2990 },
        description: '适合中小企业和专业团队',
        features: [
          '每月10,000次查询',
          '高级AI数据分析',
          '自然语言交互',
          'Agent + Tool 智能调度',
          '多种图表和报告',
          '优先技术支持',
          '数据存储100GB',
          'API访问权限',
          '团队协作功能'
        ],
        limitations: [],
        cta: '立即购买',
        popular: true,
        variant: 'primary'
      },
      {
        name: '企业版',
        price: { monthly: 999, yearly: 9990 },
        description: '适合大型企业和复杂业务场景',
        features: [
          '无限次查询',
          '企业级AI数据分析',
          'Oracle 原生深度整合',
          '私有知识库上云',
          '多模数据融合分析',
          '7x24小时专属支持',
          '无限数据存储',
          '高级API和集成',
          '单点登录(SSO)',
          '数据安全合规',
          '定制化开发',
          '专属客户成功经理'
        ],
        limitations: [],
        cta: '立即购买',
        popular: false,
        variant: 'outline'
      }
    ],
    features: [
      {
        category: '核心功能',
        items: [
          { name: '自然语言查询', free: '✓', pro: '✓', enterprise: '✓' },
          { name: 'Agent + Tool 智能调度', free: '✗', pro: '✓', enterprise: '✓' },
          { name: 'Oracle 原生支持', free: '✗', pro: '基础', enterprise: '高级' },
          { name: '多模数据融合', free: '✗', pro: '✓', enterprise: '✓' },
          { name: '私有知识库', free: '✗', pro: '✗', enterprise: '✓' }
        ]
      },
      {
        category: '使用限制',
        items: [
          { name: '月查询次数', free: '100', pro: '10,000', enterprise: '无限' },
          { name: '数据存储', free: '1GB', pro: '100GB', enterprise: '无限' },
          { name: '用户数量', free: '1', pro: '10', enterprise: '无限' },
          { name: 'API调用', free: '✗', pro: '1,000/月', enterprise: '无限' }
        ]
      },
      {
        category: '支持服务',
        items: [
          { name: '技术支持', free: '邮件', pro: '优先支持', enterprise: '7x24专属' },
          { name: '培训服务', free: '✗', pro: '在线培训', enterprise: '现场培训' },
          { name: '定制开发', free: '✗', pro: '✗', enterprise: '✓' },
          { name: '客户成功经理', free: '✗', pro: '✗', enterprise: '✓' }
        ]
      }
    ],
    faqs: [
      {
        question: '可以免费试用吗？',
        answer: '是的，我们提供免费版本，包含基础功能。专业版和企业版也提供14天免费试用。'
      },
      {
        question: '如何升级或降级套餐？',
        answer: '您可以随时在账户设置中升级或降级套餐，变更将在下个计费周期生效。'
      },
      {
        question: '支持哪些支付方式？',
        answer: '我们支持信用卡、银行转账、支付宝等多种支付方式。企业客户可申请发票。'
      },
      {
        question: '数据安全如何保障？',
        answer: '我们采用企业级安全措施，包括数据加密、访问控制、安全审计等，确保您的数据安全。'
      },
      {
        question: '可以取消订阅吗？',
        answer: '可以随时取消订阅，取消后您仍可使用至当前计费周期结束。'
      }
    ],
    common: {
      popular: '最受欢迎',
      month: '月',
      year: '年',
      mobileHint: '💡 提示：向左滑动查看更多计划，或使用下方功能对比查看详细差异',
      featureComparison: '功能对比',
      featureComparisonDesc: '详细了解各版本的功能差异',
      faq: '常见问题',
      faqDesc: '关于定价和服务的常见问题解答',
      featuresIncluded: '包含功能：',
      limitations: '限制：'
    },
    cta: {
      title: '准备开始您的数据智能之旅？',
      subtitle: '立即开始14天免费试用，无需信用卡',
      buttons: {
        trial: '免费试用',
        contact: '联系销售'
      }
    }
  },

  // 资源页面
  resources: {
    seo: {
      title: '资源中心 - DecisionAI 2.0 | 文档、指南、API和技术资源',
      description: '获取DecisionAI 2.0的完整资源，包括产品文档、使用指南、API文档、技术博客和视频教程。'
    },
    hero: {
      badge: '资源中心',
      title: '学习资源',
      titleHighlight: ' 一站式获取',
      subtitle: '从产品文档到技术博客，从API参考到视频教程，获取您需要的所有资源'
    },
    featured: {
      title: '推荐资源',
      subtitle: '最受欢迎和最有价值的学习资源'
    },
    categories: [
      { id: 'all', name: '全部资源' },
      { id: 'docs', name: '产品文档' },
      { id: 'guides', name: '使用指南' },
      { id: 'api', name: 'API文档' },
      { id: 'blog', name: '技术博客' },
      { id: 'videos', name: '视频教程' }
    ],
    resourceList: [
      {
        id: 1,
        category: 'docs',
        type: '产品文档',
        title: 'DecisionAI 2.0 产品介绍',
        description: '全面了解DecisionAI 2.0的核心功能、技术架构和应用场景',
        format: 'PDF',
        size: '2.5MB',
        downloadUrl: '#',
        readTime: '15分钟',
        featured: true
      },
      {
        id: 2,
        category: 'guides',
        type: '快速入门',
        title: '5分钟快速上手指南',
        description: '从零开始，快速掌握DecisionAI 2.0的基本使用方法',
        format: 'PDF',
        size: '1.8MB',
        downloadUrl: '#',
        readTime: '5分钟',
        featured: true
      },
      {
        id: 3,
        category: 'api',
        type: 'API文档',
        title: 'REST API 参考手册',
        description: '完整的API接口文档，包含请求参数、响应格式和示例代码',
        format: '在线文档',
        size: '-',
        downloadUrl: '#',
        readTime: '30分钟',
        featured: false
      },
      {
        id: 4,
        category: 'guides',
        type: '部署指南',
        title: '企业级部署最佳实践',
        description: '详细的部署指南，包含安全配置、性能优化和故障排除',
        format: 'PDF',
        size: '3.2MB',
        downloadUrl: '#',
        readTime: '25分钟',
        featured: false
      },
      {
        id: 5,
        category: 'blog',
        type: '技术博客',
        title: 'Agent + Tool 架构深度解析',
        description: '深入解析DecisionAI 2.0的核心架构设计理念和技术实现',
        format: '在线文章',
        size: '-',
        downloadUrl: '#',
        readTime: '12分钟',
        featured: true
      },
      {
        id: 6,
        category: 'videos',
        type: '视频教程',
        title: '产品演示视频合集',
        description: '通过实际案例演示，了解DecisionAI 2.0在不同场景下的应用',
        format: '视频',
        size: '120MB',
        downloadUrl: '#',
        readTime: '45分钟',
        featured: false
      },
      {
        id: 7,
        category: 'docs',
        type: '技术白皮书',
        title: '企业级AI数据分析白皮书',
        description: '深度分析企业AI数据分析的发展趋势、技术挑战和解决方案',
        format: 'PDF',
        size: '4.1MB',
        downloadUrl: '#',
        readTime: '35分钟',
        featured: false
      },
      {
        id: 8,
        category: 'guides',
        type: '集成指南',
        title: 'Oracle数据库集成指南',
        description: '详细说明如何将DecisionAI 2.0与Oracle数据库进行深度集成',
        format: 'PDF',
        size: '2.8MB',
        downloadUrl: '#',
        readTime: '20分钟',
        featured: false
      }
    ],
    common: {
      readTime: '阅读时间',
      size: '大小',
      getResource: '获取资源',
      get: '获取',
      featured: '推荐'
    },
    help: {
      title: '需要更多帮助？',
      subtitle: '我们的技术团队随时为您提供支持，帮助您更好地使用DecisionAI 2.0',
      support: {
        email: {
          title: '邮件支持',
          contact: 'support@decisionai.com'
        },
        chat: {
          title: '在线客服',
          hours: '工作日 9:00-18:00'
        },
        phone: {
          title: '电话支持',
          number: '400-898-7779'
        }
      },
      buttons: {
        contact: '联系技术支持',
        training: '预约培训'
      }
    }
  },

  // 客户案例
  customerCases: {
    badge: '客户成功案例',
    title: '真实客户案例 & 成果展示',
    subtitle: '基于真实演示场景，看看不同行业的客户如何通过DAI 2.0实现数据智能转型',
    mobileHint: '💡 提示：左右滑动查看不同行业案例，点击卡片查看详细成果',
    stats: {
      clients: '企业客户',
      analysisTime: '平均分析时间',
      efficiency: '效率提升',
      minute: '分钟'
    },
    industries: {
      ecommerce: '电商零售',
      finance: '金融服务',
      manufacturing: '生产制造'
    },
    cases: {
      ecommerce: {
        company: '某大型电商平台',
        industry: '电商零售',
        background: '日均订单量100万+，需要实时分析用户行为和销售趋势',
        challenge: '传统BI工具响应慢，业务人员依赖技术团队，分析周期长达2-3天',
        solution: 'DAI 2.0 Agent + Tool架构，自然语言问数，智能任务分解',
        results: [
          { metric: '分析效率', improvement: '提升60%', detail: '从天级缩短到分钟级' },
          { metric: '决策时间', improvement: '缩短90%', detail: '从2-3天到3分钟' },
          { metric: '自助分析率', improvement: '提升80%', detail: '业务人员独立完成分析' }
        ],
        testimonial: 'DAI 2.0让我们的运营团队第一次能够独立完成复杂的数据分析，从"最近一个月销量下滑的原因是什么？"这样的问题，到获得包含具体决策建议的完整报告，只需要3分钟。',
        person: '数据运营总监',
        realExample: {
          question: '最近一个月销量下滑的原因是什么？',
          analysis: 'Agent智能分解为5个步骤：总体趋势→产品类别→品牌维度→促销影响→退货分析',
          insight: '发现电脑类别销售额下降214万，戴尔、华为等品牌表现不佳，五一促销活动结束是主要影响因素',
          recommendation: '建议针对电脑类别制定专项促销策略，重点关注戴尔、华为品牌的市场表现'
        }
      },
      finance: {
        company: '某金融机构',
        industry: '金融服务',
        background: '复杂的风控分析需求，涉及多源数据和关联关系分析',
        challenge: '关联关系分析复杂，需要专业数据分析师，风险识别周期长',
        solution: 'Oracle图数据库+向量数据库深度整合，多Tool协同分析',
        results: [
          { metric: '风险识别准确率', improvement: '提升25%', detail: '多模数据融合分析' },
          { metric: '分析维度', improvement: '扩展3倍', detail: '从单一到多模数据' },
          { metric: '专家经验复用', improvement: '提升100%', detail: '一键注册为Tool' }
        ],
        testimonial: '通过DAI 2.0的Agent + Tool架构，我们能够同时调用SQL Tool、Graph Tool和Vector Tool，实现财务数据、关联关系和舆情文本的一站式分析。',
        person: '风控部门负责人',
        realExample: {
          question: '分析A公司的整体风险状况',
          analysis: 'Agent调度SQL Tool查询财务数据，Graph Tool分析关联关系，Vector Tool检索舆情文本',
          insight: '发现A公司财务指标异常，存在复杂的关联交易路径，舆情中出现负面信息',
          recommendation: '综合风险评估为高风险，建议暂停合作并加强监控'
        }
      },
      manufacturing: {
        company: '某制造企业',
        industry: '生产制造',
        background: '供应链数据分散，决策依赖经验，缺乏统一分析平台',
        challenge: '数据孤岛严重，缺乏统一分析平台，专家经验难以传承',
        solution: '私有知识快速上云，多Tool协同，专家经验一键注册',
        results: [
          { metric: '供应链透明度', improvement: '提升40%', detail: '全链路数据打通' },
          { metric: '库存优化', improvement: '节省成本15%', detail: '智能预测和建议' },
          { metric: '决策数据化', improvement: '提升70%', detail: '从经验到数据驱动' }
        ],
        testimonial: 'DAI 2.0让我们的供应链专家经验能够快速数字化，新员工也能通过自然语言问答获得专业级的分析结果。',
        person: '供应链总监',
        realExample: {
          question: '优化库存配置，降低成本',
          analysis: '调用供应链专家Tool，分析历史数据和市场趋势，预测需求变化',
          insight: '发现某些原材料库存过高，部分产品需求季节性波动明显',
          recommendation: '调整库存策略，优化采购计划，预计可节省成本15%'
        }
      }
    },
    labels: {
      background: '项目背景',
      challenge: '面临挑战',
      solution: 'DAI 2.0 解决方案',
      results: '量化成果',
      testimonial: '客户评价',
      realAnalysis: '真实分析案例',
      analysisQuestion: '分析问题',
      agentProcess: 'Agent + Tool 分析过程',
      insights: '智能洞察发现',
      recommendations: '决策建议',
      moreResults: '更多成果',
      viewDetails: '查看详情',
      collapse: '收起'
    }
  },

  // 数据驱动决策区域
  dataDecision: {
    title: '每个人，每个企业，都需要数据驱动决策',
    scenarios: {
      onlineAds: {
        title: '在线广告',
        description: '即时数据帮助分析，投放ROI提升',
        features: [
          '广告投放',
          '直播投放'
        ]
      },
      ecommerce: {
        title: '电商零售',
        description: '数据驱动精准决策，增长加速',
        features: [
          '会员经营',
          '爆品打造',
          '渠道管理',
          '拉新留存'
        ]
      },
      manufacturing: {
        title: '生产制造',
        description: '复杂数据敏捷分析，经营提效',
        features: [
          '供销存管理',
          '微信营销'
        ]
      },
      franchise: {
        title: '连锁加盟',
        description: '数据共享即时查询，合作提升',
        features: [
          '加盟管理',
          '投资回报管理'
        ]
      }
    }
  },

  // 页脚
  footer: {
    quickLinks: '快速链接',
    contactUs: '联系我们',
    aboutUs: '关于我们',
    phone: '400-898-7779',
    copyright: '猎豹移动© 2025',
    decisionAICopyright: '© 2025 DecisionAI',
    privacyPolicy: '隐私政策',
    orionStar: '猎户星空',
    qrCodeAlt: '二维码',
    wechatQR: '微信公众号',
    productServices: '产品服务',
    companyInfo: 'DecisionAI 2.0 - 让数据开口说话，让决策更加智能。基于 Agent + Tool 智能调度架构，3分钟让 Oracle 数据库变身 AI 助手。',
    coreFeatures: '核心功能',
    industrySolutions: '行业方案'
  },

  // Demo对话内容
  conversations: {
    retail_1: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "最近一个月销量下滑的原因是什么？",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n分析最近一个月销售额下降的可能原因，通过对比近期与前期销售数据，并从产品、促销、退货等维度探查异常。\n\n📋 **执行步骤规划**\n1. 计算总体销售额变化趋势\n2. 多维度深入分析（产品类别、品牌、促销）\n3. 生成综合分析报告和决策建议",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "总体趋势分析",
          ai: "🔍 **执行工具: 自动SQL查询**\n⏱️ **耗时: 1.168 ms**\n\n```sql\nSELECT SUM(payment_amount) AS recent_month_sales,\n(SELECT SUM(payment_amount) FROM orders \n WHERE order_date >= DATE_SUB('2025-06-11', INTERVAL 2 MONTH)\n AND order_date < DATE_SUB('2025-06-11', INTERVAL 1 MONTH))\nAS previous_month_sales FROM orders\nWHERE order_date >= DATE_SUB('2025-06-11', INTERVAL 1 MONTH)\n```\n\n📊 **查询结果**\n• 最近一个月销售额: 27,047,017 元\n• 前一个月销售额: 27,918,177 元\n• **销售额下降: 871,160 元 (3.1%)**\n\n📈 **智能图表分析**\n趋势图表已生成",
          description: "SQL Tool执行数据查询，确认销售下滑趋势",
          chart: "line"
        },
        step3: {
          phase: "多维度深入分析",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **产品类别分析** (耗时: 1.029 ms)\n• **电脑类别**: 11,140,872 元 (下降 2,144,037 元) ⚠️\n• **手机类别**: 8,397,633 元 (上升 408,313 元) ✅\n• **平板类别**: 5,289,652 元 (上升 595,749 元) ✅\n• **智能穿戴**: 2,218,860 元 (上升 268,815 元) ✅\n\n🏷️ **品牌维度分析** (耗时: 0.957 ms)\n• **戴尔**: 2,682,011 元 (下降 857,601 元) ⚠️\n• **华为**: 2,863,268 元 (下降 178,621 元) ⚠️\n• **联想**: 2,574,447 元 (下降 129,369 元) ⚠️\n• **苹果**: 9,467,175 元 (下降 98,225 元) ⚠️\n\n🎯 **促销影响分析** (耗时: 0.878 ms)\n• **五一促销结束影响**: 752,247 元\n• **退货情况改善**: 非下滑原因\n\n🎯 **关键发现**\n**电脑类别销售大幅下降**，戴尔品牌表现最差\n\n📈 **智能图表分析**\n多维分析图表已生成",
          description: "Agent调度多Tool并行分析，全面诊断问题",
          chart: "bar"
        },
        step4: {
          phase: "综合分析报告",
          ai: "📋 **《销量下滑原因分析报告》**\n\n🎯 **核心结论**\n最近一个月销售额下降 3.1%，主要原因：\n\n⚠️ **主要原因**\n1. **电脑类别销售大幅下降** (下降214万元)\n2. **戴尔品牌表现最差** (下降86万元)\n3. **五一促销活动结束** (影响75万元)\n\n💡 **决策建议**\n• 重点关注电脑类别，深入分析具体型号\n• 与戴尔、华为等品牌沟通市场策略\n• 考虑推出针对性促销活动\n• 制定电脑品牌定向促销策略\n\n✅ **分析完成**\n基于多维度数据分析，为您提供可执行的业务决策建议",
          description: "生成完整的分析报告和决策建议"
        }
      }
    },
    retail_2: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "过去一年，哪些产品卖的好？",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n识别过去一年中销售表现最好的产品，根据总利润来衡量产品的受欢迎程度和盈利能力。\n\n📋 **执行步骤规划**\n1. 计算过去一年每个产品的总利润\n2. 按利润排序识别热销产品\n3. 分析产品类别和品牌特征",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "产品利润分析",
          ai: "🔍 **执行工具: 自动SQL查询**\n⏱️ **耗时: 1.474 ms**\n\n```sql\nSELECT p.product_name, SUM(o.profit) AS total_profit \nFROM orders o JOIN products p ON o.product_id = p.product_id \nWHERE o.order_date >= DATE_SUB('2025-06-24', INTERVAL 1 YEAR) \nGROUP BY p.product_name ORDER BY total_profit DESC LIMIT 10\n```\n\n📊 **查询结果**\n• MacBook Pro 16\": 6,021,548 元\n• MacBook Pro 14\": 5,660,905 元\n• Alienware m15: 4,793,296 元\n• Galaxy Z Fold5: 4,286,622 元\n• iMac 24\": 3,997,009 元\n\n📈 **智能图表分析**\n产品利润排行图表已生成",
          description: "SQL Tool执行数据查询，获取产品利润排行",
          chart: "bar"
        },
        step3: {
          phase: "产品特征分析",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **产品类别分析**\n• **笔记本电脑**: 占据前十中的6席，总利润超3000万\n• **智能手机**: Galaxy Z Fold5、iPhone 15 Pro Max表现突出\n• **一体机**: iMac 24\"进入前五，苹果生态优势明显\n• **平板电脑**: iPad Pro 12.9\"稳定盈利\n\n🏷️ **品牌表现分析**\n• **苹果**: 4款产品入榜，品牌溢价能力强\n• **戴尔**: Alienware、XPS系列高端定位成功\n• **三星**: 折叠屏手机创新获得市场认可\n• **联想**: ThinkPad商务本稳定表现\n\n🎯 **关键发现**\n**高端产品利润贡献最大**，苹果生态系统表现突出",
          description: "深入分析产品类别和品牌特征",
          chart: "pie"
        },
        step4: {
          phase: "市场洞察报告",
          ai: "📋 **《热销产品分析报告》**\n\n🎯 **核心结论**\n过去一年高端产品是主要利润驱动力\n\n⚠️ **关键发现**\n1. **高端笔记本电脑主导市场** (前十中占6席)\n2. **苹果生态系统盈利突出** (4款产品入榜)\n3. **创新产品获得溢价** (折叠屏手机表现优异)\n\n💡 **策略建议**\n• 持续深耕高端笔记本市场，关注新技术趋势\n• 强化与苹果等头部品牌的合作关系\n• 关注折叠屏等创新产品的市场机会\n• 优化高利润产品的库存和营销策略\n\n✅ **分析完成**\n基于产品利润数据，为您提供市场策略建议",
          description: "生成完整的产品分析报告和策略建议"
        }
      }
    },
    retail_3: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "分析客户购买行为，识别高价值客户群体",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n通过分析客户购买行为数据，识别高价值客户群体，为精准营销和客户关系管理提供数据支持。\n\n📋 **执行步骤规划**\n1. 分析客户消费金额分布\n2. 识别客户购买频次特征\n3. 构建客户价值分层模型\n4. 生成客户群体洞察报告",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "客户消费分析",
          ai: "🔍 **执行工具: 自动SQL查询**\n⏱️ **耗时: 1.256 ms**\n\n```sql\nSELECT \n  CASE \n    WHEN total_amount >= 50000 THEN '高价值客户'\n    WHEN total_amount >= 20000 THEN '中价值客户'\n    WHEN total_amount >= 5000 THEN '普通客户'\n    ELSE '低价值客户'\n  END AS customer_segment,\n  COUNT(*) AS customer_count,\n  AVG(total_amount) AS avg_amount\nFROM (\n  SELECT customer_id, SUM(payment_amount) AS total_amount\n  FROM orders WHERE order_date >= DATE_SUB(NOW(), INTERVAL 1 YEAR)\n  GROUP BY customer_id\n) customer_totals\nGROUP BY customer_segment\n```\n\n📊 **查询结果**\n• 高价值客户: 1,247人，平均消费78,650元\n• 中价值客户: 3,892人，平均消费32,180元\n• 普通客户: 12,567人，平均消费8,920元\n• 低价值客户: 28,394人，平均消费2,340元\n\n📈 **智能图表分析**\n客户价值分布图表已生成",
          description: "分析客户消费金额分布和价值分层",
          chart: "pie"
        },
        step3: {
          phase: "客户行为深度分析",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **高价值客户特征**\n• **消费频次**: 平均每月购买3.2次\n• **偏好品类**: 高端笔记本(45%)、智能手机(28%)、平板电脑(18%)\n• **购买时间**: 工作日下午和周末上午活跃\n• **客单价**: 平均2,450元/单\n\n💰 **中价值客户特征**\n• **消费频次**: 平均每月购买1.8次\n• **偏好品类**: 中端笔记本(38%)、智能手机(32%)、配件(20%)\n• **购买时间**: 周末和节假日集中\n• **客单价**: 平均1,780元/单\n\n👥 **普通客户特征**\n• **消费频次**: 平均每月购买0.9次\n• **偏好品类**: 入门笔记本(42%)、手机配件(35%)、数码产品(15%)\n• **购买时间**: 促销期间集中购买\n• **客单价**: 平均990元/单\n\n📈 **关键洞察**\n**高价值客户贡献65%营收**，但仅占客户总数的2.7%",
          description: "深入分析不同价值客户群体的行为特征",
          chart: "bar"
        },
        step4: {
          phase: "客户价值洞察报告",
          ai: "📋 **《客户行为洞察分析报告》**\n\n🎯 **核心结论**\n客户价值呈现明显的二八分布特征\n\n⚠️ **关键发现**\n1. **高价值客户贡献突出** (2.7%客户贡献65%营收)\n2. **中价值客户增长潜力大** (8.4%客户群体可重点培养)\n3. **普通客户基数庞大** (27.2%客户需要激活策略)\n4. **低价值客户占比过高** (61.7%需要转化或筛选)\n\n💡 **营销策略建议**\n• **高价值客户**: VIP专属服务，新品优先体验，个性化推荐\n• **中价值客户**: 升级激励计划，品类交叉销售，会员权益提升\n• **普通客户**: 促销活动引导，社群营销，复购激励\n• **低价值客户**: 自动化营销，成本控制，价值筛选\n\n✅ **分析完成**\n基于客户行为数据，为您提供精准营销策略建议",
          description: "生成完整的客户价值洞察报告和营销策略"
        }
      }
    },
    mfg_1: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "帮我分析各基地3月份每日排产目标",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n分析并展示各基地在3月份每一天的排产目标，识别生产计划趋势和异常情况。\n\n📋 **执行步骤规划**\n1. 从数据库获取3月份各基地每日排产目标\n2. 分析各基地排产趋势和特点\n3. 提供生产计划优化建议",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "排产数据查询",
          ai: "🔍 **执行工具: 自动SQL查询**\n⏱️ **耗时: 1.031 ms**\n\n```sql\nSELECT `基地名称`, `日期`, `排产目标(A)` \nFROM `中新赛克治理数据` \nWHERE `日期` LIKE '3月%' \nORDER BY `基地名称`, `日期` LIMIT 1000\n```\n\n📊 **查询结果**\n• 内蒙基地：3月排产目标8,829-12,269\n• 天津基地：3月排产目标12,279-19,428\n• 宜兴基地：3月排产目标15,937-33,283\n• **总计：121条记录**\n\n📈 **智能图表分析**\n排产趋势图表已生成",
          description: "查询各基地3月份每日排产目标数据",
          chart: "line"
        },
        step3: {
          phase: "排产趋势分析",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **内蒙基地趋势**\n• **月初**: 8,600-8,800左右稳定\n• **月中**: 逐渐爬升至12,000以上\n• **月末**: 高位波动后回落至9,926\n• **特点**: 先上升后在高位波动再回落\n\n🏭 **天津基地趋势**\n• **波动范围**: 12,279-19,428之间\n• **变化特点**: 每日目标值变化频繁\n• **最高峰**: 3月7日达到19,428\n• **特点**: 波动较大，无明显持续趋势\n\n🏗️ **宜兴基地趋势**\n• **月初**: 约15,937（汇总值）\n• **月末**: 约33,283（汇总值）\n• **增长幅度**: 超过100%增长\n• **特点**: 明显的持续上升趋势\n\n📈 **智能图表分析**\n基地对比分析图表已生成",
          description: "深入分析各基地排产趋势和特点",
          chart: "bar"
        },
        step4: {
          phase: "优化建议报告",
          ai: "📋 **《排产目标分析报告》**\n\n🎯 **核心结论**\n各基地3月份排产目标呈现不同特点和趋势\n\n⚠️ **关键发现**\n1. **宜兴基地产能快速提升** (增长超100%)\n2. **天津基地计划波动较大** (需要稳定性改进)\n3. **内蒙基地阶段性调整** (月末目标回落)\n\n💡 **优化建议**\n• 内蒙基地：分析月末回落原因，优化后续计划\n• 天津基地：识别波动因素，平滑生产计划\n• 宜兴基地：关注产能提升的可持续性\n• 建立跨基地产能协调机制\n\n✅ **分析完成**\n基于排产数据分析，为您提供生产计划优化建议",
          description: "生成完整的排产分析报告和优化建议"
        }
      }
    },
    mfg_2: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "宜兴各个工厂的每日趋势怎么样？",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n查看宜兴基地各个工厂在3月份的每日关键指标趋势，包括入库、合格率、报废率等。\n\n📋 **执行步骤规划**\n1. 确认宜兴基地的工厂构成\n2. 获取各工厂每日关键指标数据\n3. 分析工厂间的表现差异和趋势",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "工厂数据查询",
          ai: "🔍 **执行工具: 自动SQL查询**\n⏱️ **耗时: 0.987 ms**\n\n```sql\nSELECT `日期`, `工厂名称`, \nCAST(`入库(A)` AS DECIMAL(10, 2)) AS `入库(A)`,\nCAST(REPLACE(`合格率`, '%', '') AS DECIMAL(10, 2)) AS `合格率`\nFROM `中新赛克治理数据` \nWHERE `基地名称` = '宜兴' AND `日期` LIKE '3月%'\n```\n\n📊 **查询结果**\n• 一二期工厂：入库7.11-11.47吨，合格率98-99%\n• 三期工厂：入库1.79-12.85吨，合格率98-99%\n• **总计：60条记录**\n\n📈 **智能图表分析**\n工厂对比趋势图表已生成",
          description: "查询宜兴基地各工厂每日关键指标"
        },
        step3: {
          phase: "工厂表现分析",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **一二期工厂表现**\n• **入库趋势**: 7-11吨波动，月末达11.47吨\n• **合格率**: 稳定在98%以上\n• **报废率**: 绝大多数日期低于0.1%\n• **特点**: 相对稳定，波动幅度较小\n\n🏭 **三期工厂表现**\n• **入库趋势**: 2-13吨大幅增长，月末超过一二期\n• **合格率**: 98%以上，略有波动\n• **报废率**: 偶尔高于0.1%，最高0.23%\n• **特点**: 明显增长势头，产能快速爬坡\n\n📈 **对比分析**\n• **产能增长**: 三期工厂增长更快\n• **质量稳定性**: 一二期工厂更稳定\n• **月末表现**: 三期工厂超越一二期\n\n📈 **智能图表分析**\n工厂表现对比图表已生成",
          description: "深入分析各工厂表现差异和趋势",
          chart: "bar"
        },
        step4: {
          phase: "工厂优化建议",
          ai: "📋 **《宜兴工厂趋势分析报告》**\n\n🎯 **核心结论**\n宜兴基地两个工厂呈现不同发展趋势\n\n⚠️ **关键发现**\n1. **三期工厂快速增长** (入库量月末超过一二期)\n2. **一二期工厂稳定运行** (各项指标波动较小)\n3. **质量控制总体良好** (合格率均在98%以上)\n\n💡 **优化建议**\n• 深入分析三期工厂增长驱动因素\n• 关注排产达成率的波动原因\n• 持续监控报废率变化\n• 对比分析两厂运营模式，互相借鉴\n\n✅ **分析完成**\n基于工厂数据分析，为您提供运营优化建议",
          description: "生成完整的工厂分析报告和优化建议"
        }
      }
    },
    mfg_3: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "上个月三个基地的碎片是多少？",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n统计上个月三个生产基地的碎片数量，分析各基地质量控制情况，识别异常基地并提供改进建议。\n\n📋 **执行步骤规划**\n1. 查询三个基地的碎片统计数据\n2. 对比分析各基地质量表现\n3. 识别异常原因并提供优化建议",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "数据查询分析",
          ai: "🔍 **执行工具: 自动SQL查询**\n⏱️ **耗时: 1.021 ms**\n\n```sql\nSELECT `基地名称`, AVG(CAST(REPLACE(`碎片率(不含报废率)`, '%', '') AS DECIMAL(10, 2))) AS avg_fragmentation_rate \nFROM `中新赛克治理数据` \nWHERE `月份` = '2025-03' GROUP BY `基地名称`\n```\n\n📊 **查询结果**\n• 内蒙基地：0.18%碎片率\n• 天津基地：0.16%碎片率\n• 宜兴基地：0.105%碎片率\n• **总计：3个基地数据**\n\n📈 **智能图表分析**\n基地碎片率对比图表已生成",
          description: "查询并统计各基地碎片率数据",
          chart: "bar"
        },
        step3: {
          phase: "质量分析诊断",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **质量表现对比**\n• **宜兴基地**: 碎片率最低(0.105%)，质量控制最佳 ✅\n• **天津基地**: 碎片率中等(0.16%)，表现良好 ✅\n• **内蒙基地**: 碎片率最高(0.18%)，需要改进 ⚠️\n\n🏷️ **差异分析**\n• **设备状态**: 内蒙基地设备可能需要维护\n• **操作规范**: 宜兴基地执行标准最严格\n• **环境因素**: 各基地生产环境差异影响\n• **人员培训**: 培训水平存在差异\n\n🎯 **关键发现**\n**宜兴基地可作为质量标杆**，内蒙基地需重点改进\n\n📈 **智能图表分析**\n质量趋势分析图表已生成",
          description: "深入分析各基地质量控制差异原因",
          chart: "line"
        },
        step4: {
          phase: "改进建议报告",
          ai: "📋 **《质量控制分析报告》**\n\n🎯 **核心结论**\n上个月三基地碎片率差异明显，宜兴基地表现最优\n\n⚠️ **关键发现**\n1. **宜兴基地质量最优** (0.105%碎片率)\n2. **内蒙基地需要改进** (0.18%碎片率)\n3. **质量管理存在差异** (最高与最低相差71%)\n\n💡 **改进建议**\n• 推广宜兴基地的质量管理经验\n• 内蒙基地：加强设备维护和人员培训\n• 建立跨基地质量对标体系\n• 定期开展质量管理交流和培训\n\n✅ **分析完成**\n基于质量数据分析，为您提供针对性改进方案",
          description: "生成完整的质量分析报告和改进建议"
        }
      }
    },
    fin_1: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "请帮我评估一下ABC公司是否存在贷款风险",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n评估ABC公司的潜在贷款风险，需要综合分析其基本信息、财务状况、负面新闻等多个维度。\n\n📋 **执行步骤规划**\n1. 获取公司基本注册信息和经营状态\n2. 分析资金流转情况和财务健康状况\n3. 查找负面新闻和声誉风险评估",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "基本信息查询",
          ai: "🔍 **执行工具: 公司基本信息查询**\n⏱️ **耗时: 1.586 ms**\n\n📊 **查询结果**\n• 公司名称：ABC公司\n• 注册资本：11,165,000元\n• 纳税信用等级：A级信用\n• 经营状态：正常\n• 是否失信企业：否\n• 近三年被告次数：0\n• 近一年负面舆情：0\n\n📈 **智能图表分析**\n公司基本画像图表已生成",
          description: "获取公司基本注册信息和信用状况",
          chart: "bar"
        },
        step3: {
          phase: "风险综合分析",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **资金流转分析** (耗时: 7.082 ms)\n• **与GHI公司交易**: 21万元，标记为中风险 ⚠️\n• **其他公司交易**: 金额较小，标记为低风险 ✅\n• **交易频率**: 正常范围内\n• **异常标识**: 需关注GHI公司关联风险\n\n🏷️ **负面新闻分析** (耗时: 2.803 ms)\n• **发现负面新闻**: 1条\n• **事件内容**: 算力服务合同不实信息\n• **影响评估**: 可能损害公司声誉\n• **风险等级**: 中等声誉风险\n\n🎯 **企业信用报告** (耗时: 2.567 ms)\n• **纳税状态**: 正常\n• **注册信息**: 基本一致\n• **信用记录**: 良好\n\n🎯 **关键发现**\n**整体信用良好**，但存在资金往来和声誉风险",
          description: "多维度分析公司风险状况",
          chart: "radar"
        },
        step4: {
          phase: "风险评估报告",
          ai: "📋 **《ABC公司贷款风险评估报告》**\n\n🎯 **核心结论**\nABC公司整体信用状况良好，但存在一定潜在风险\n\n⚠️ **风险识别**\n1. **资金流转风险** (与GHI公司频繁往来)\n2. **声誉风险** (算力服务合同不实信息)\n3. **信息一致性风险** (注册地址存在差异)\n\n💡 **风控建议**\n• 深入调查与GHI公司的资金往来背景\n• 评估负面新闻对公司声誉的长期影响\n• 核实注册地址信息的一致性\n• 结合财务报表进行更全面的风险评估\n\n✅ **分析完成**\n基于多维度风险分析，建议谨慎放贷并加强监控",
          description: "生成完整的风险评估报告和风控建议"
        }
      }
    },
    fin_2: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "基于历史收益数据，优化投资组合配置建议",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n基于历史收益数据分析，为您提供科学的投资组合优化配置建议，平衡风险与收益。\n\n📋 **执行步骤规划**\n1. 分析各类资产历史收益表现\n2. 计算风险收益比和相关性\n3. 构建最优投资组合配置\n4. 生成投资建议和风险提示",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "历史收益分析",
          ai: "🔍 **执行工具: 资产收益数据查询**\n⏱️ **耗时: 2.156 ms**\n\n```sql\nSELECT asset_type, year, annual_return, volatility, sharpe_ratio\nFROM investment_performance \nWHERE year >= 2019 AND year <= 2023\nORDER BY asset_type, year\n```\n\n📊 **查询结果**\n• **股票型基金**: 年化收益8.5%-15.2%，波动率18.3%\n• **债券型基金**: 年化收益3.2%-6.8%，波动率4.2%\n• **混合型基金**: 年化收益5.8%-11.4%，波动率12.1%\n• **货币基金**: 年化收益2.1%-3.5%，波动率0.8%\n• **黄金ETF**: 年化收益-2.3%-12.8%，波动率16.7%\n\n📈 **智能图表分析**\n资产收益趋势图表已生成",
          description: "分析各类资产的历史收益表现",
          chart: "line"
        },
        step3: {
          phase: "风险收益优化",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n📊 **相关性分析**\n• **股票-债券相关性**: -0.23 (负相关，有效分散风险)\n• **股票-黄金相关性**: 0.15 (低相关性)\n• **债券-货币相关性**: 0.68 (中等正相关)\n• **混合-股票相关性**: 0.82 (高相关性)\n\n⚖️ **风险收益优化计算**\n• **保守型组合**: 股票20% + 债券50% + 货币30%\n  - 预期年化收益: 5.2%，风险等级: 低\n• **平衡型组合**: 股票40% + 债券30% + 混合20% + 货币10%\n  - 预期年化收益: 7.8%，风险等级: 中\n• **积极型组合**: 股票60% + 混合25% + 债券10% + 黄金5%\n  - 预期年化收益: 10.5%，风险等级: 高\n\n🎯 **夏普比率排名**\n1. 平衡型组合: 0.64\n2. 保守型组合: 0.58\n3. 积极型组合: 0.52",
          description: "计算最优投资组合配置方案"
        },
        step4: {
          phase: "投资建议报告",
          ai: "📋 **《投资组合优化配置报告》**\n\n🎯 **推荐方案**\n**平衡型投资组合** (最优夏普比率)\n\n💼 **配置详情**\n• **股票型基金**: 40% (预期收益贡献4.2%)\n• **债券型基金**: 30% (预期收益贡献1.5%)\n• **混合型基金**: 20% (预期收益贡献1.6%)\n• **货币基金**: 10% (预期收益贡献0.3%)\n\n📈 **预期表现**\n• **年化收益率**: 7.8%\n• **年化波动率**: 9.2%\n• **夏普比率**: 0.64\n• **最大回撤**: 预计-12.5%\n\n💡 **投资建议**\n• 建议分批建仓，降低时点风险\n• 每季度重新平衡一次配置比例\n• 关注市场环境变化，适时调整\n• 保持3-6个月应急资金在货币基金\n\n⚠️ **风险提示**\n历史收益不代表未来表现，投资需谨慎\n\n✅ **分析完成**\n基于量化分析，为您提供科学投资配置方案",
          description: "生成完整的投资组合优化报告"
        }
      }
    },
    fin_3: {
      title: "Agent + Tool 智能调度演示",
      subtitle: "精炼的智能分析流程",
      steps: {
        step1: {
          phase: "问题提出 + 意图确认",
          user: "识别异常交易模式，提升反欺诈能力",
          ai: "✓ **意图确认完成**\n\n🎯 **分析意图**\n通过机器学习算法分析交易数据，识别异常交易模式和潜在欺诈行为，提升风控能力。\n\n📋 **执行步骤规划**\n1. 获取近期交易数据进行预处理\n2. 应用异常检测算法识别可疑交易\n3. 分析异常交易特征和风险等级\n4. 生成反欺诈监控建议",
          description: "AI确认用户意图并制定分析计划"
        },
        step2: {
          phase: "交易数据分析",
          ai: "🔍 **执行工具: 交易数据查询与预处理**\n⏱️ **耗时: 3.247 ms**\n\n```sql\nSELECT transaction_id, amount, transaction_time, \n       merchant_type, user_location, device_info,\n       risk_score\nFROM transactions \nWHERE transaction_date >= DATE_SUB(NOW(), INTERVAL 7 DAY)\nAND amount > 0\nORDER BY transaction_time DESC\nLIMIT 10000\n```\n\n📊 **数据概览**\n• **总交易笔数**: 9,847笔\n• **交易金额范围**: ¥0.01 - ¥89,500\n• **平均交易金额**: ¥1,247\n• **异常交易初筛**: 156笔 (1.58%)\n• **高风险交易**: 23笔 (0.23%)\n\n📈 **智能图表分析**\n交易分布散点图已生成",
          description: "获取并预处理交易数据",
          chart: "scatter"
        },
        step3: {
          phase: "异常模式识别",
          ai: "🔄 **Agent智能调度多Tool并行分析**\n\n🤖 **机器学习异常检测**\n• **孤立森林算法**: 检测到47个异常点\n• **LOF算法**: 识别31个局部异常\n• **DBSCAN聚类**: 发现3个异常交易集群\n• **统计异常**: Z-score > 3的交易18笔\n\n⚠️ **异常交易特征分析**\n1. **金额异常**: 单笔超过¥50,000的大额交易 (8笔)\n2. **时间异常**: 凌晨2-5点高频交易 (12笔)\n3. **地理异常**: 短时间内跨地区交易 (15笔)\n4. **设备异常**: 同设备多账户交易 (7笔)\n5. **商户异常**: 高风险商户类型交易 (11笔)\n\n🎯 **风险等级分布**\n• **极高风险**: 5笔 (需立即冻结)\n• **高风险**: 18笔 (需人工审核)\n• **中风险**: 33笔 (加强监控)\n• **低风险**: 9,791笔 (正常交易)",
          description: "运用多种算法识别异常交易模式",
          chart: "scatter"
        },
        step4: {
          phase: "反欺诈监控报告",
          ai: "📋 **《交易异常检测与反欺诈报告》**\n\n🚨 **紧急处理**\n**5笔极高风险交易需立即处理**\n\n📊 **异常交易详情**\n• **交易ID: TXN_20241217_001**: ¥89,500，凌晨3:21，异地登录\n• **交易ID: TXN_20241217_045**: ¥67,800，同设备多账户\n• **交易ID: TXN_20241216_892**: ¥55,200，高风险商户\n• **交易ID: TXN_20241216_734**: ¥78,900，地理位置跳跃\n• **交易ID: TXN_20241215_456**: ¥45,600，异常时间模式\n\n🛡️ **风控建议**\n• **立即冻结**: 5笔极高风险交易账户\n• **人工审核**: 18笔高风险交易，24小时内完成\n• **加强监控**: 33笔中风险交易，设置实时预警\n• **规则优化**: 更新异常检测阈值参数\n\n📈 **模型性能**\n• **准确率**: 94.2%\n• **召回率**: 89.7%\n• **误报率**: 5.8%\n• **检测效率**: 平均3.2ms/笔\n\n💡 **系统优化建议**\n• 增加设备指纹识别维度\n• 优化地理位置异常判断逻辑\n• 建立商户风险评级动态更新机制\n\n✅ **分析完成**\n实时监控系统已更新，异常交易预警机制已激活",
          description: "生成完整的反欺诈监控报告和处理建议"
        }
      }
    }
  },

  // 最终CTA区域
  finalCTA: {
    title: '更高效的数据分析，更敏捷的经营决策',
    button: '预约演示'
  }
};
